import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "local-delivery-form",
  class LocalDeliveryForm extends WYATTElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.input = this.querySelector("input");
      this.button = this.querySelector("button");
      this.eligibleZipCodes = window.WYATT.shopify.localDelivery.zipCodes;
      this.dialog = this.closest("dialog");

      this.input.addEventListener("input", this.handleInput.bind(this));
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      this.initForm();
    }

    initForm() {
      this.savedZipCode = localStorage.getItem("local_delivery_zip_code");

      if (this.savedZipCode) {
        this.input.value = this.savedZipCode;
        this.input.dispatchEvent(new Event("input"));
      }
    }

    handleInput(event) {
      const zipCode = event.target.value;
      this.button.disabled = zipCode.length !== 5;
      this.validateZipCode(zipCode);
    }

    handleSubmit(event) {
      event.preventDefault();
      const formData = new FormData(event.target);
      const zipCode = formData.get("zip_code");

      localStorage.setItem("local_delivery_zip_code", zipCode);
      this.dialog.close();
      this.publish(window.WYATT.PubSub.events.updateLocalDeliveryZipCode, {
        zipCode,
      });
    }

    validateZipCode(zipCode) {
      if (zipCode.length < 5) {
        this.removeAttribute("data-valid");
      } else if (this.eligibleZipCodes.includes(zipCode)) {
        this.setAttribute("data-valid", "true");
      } else {
        this.setAttribute("data-valid", "false");
      }
    }
  },
);
